export const getLocalStorageValues = () => {
  let UserName = localStorage.getItem("userName");
  return {
    userName: JSON.parse(UserName) || {},
  };
};
